import { AxiosRequestConfig } from 'axios';
import { HttpClient } from 'api/http-client';
import { fieldAccessMetaToBase3 } from 'utils/field-access';
import {
  updateTaskAssigneeAndResponsibleCompany,
  updateTasksAssigneeAndResponsibleCompany,
} from 'utils/strategic-partner-utils';
import { Task } from './index';

const transformFieldAccessToBase3 = (task: Task) =>
  task.fieldsAccessMeta != null
    ? {
        ...task,
        fieldsAccessMetaInBase3: fieldAccessMetaToBase3(task.fieldsAccessMeta),
      }
    : task;
const transformFieldAccessToBase3ForTasks = (tasks: Task[]) =>
  tasks.map(transformFieldAccessToBase3);

const transformResponse = <T extends Task | Task[]>(response: T): T => {
  return (
    Array.isArray(response)
      ? updateTasksAssigneeAndResponsibleCompany(
          transformFieldAccessToBase3ForTasks(response as Task[]),
        )
      : updateTaskAssigneeAndResponsibleCompany(
          transformFieldAccessToBase3(response as Task),
        )
  ) as T;
};

export class WithNotStrategicTransformer extends HttpClient {
  getWithTransformer = <T extends Task | Task[]>(
    url: string,
    config?: AxiosRequestConfig,
  ): Promise<T> => {
    return this.get<T, T>(url, {
      ...(config ?? {}),
      params: {
        //  hasfieldsAccessMeta: true,
      },
    }).then((response) => transformResponse(response));
  };

  putWithTransformer = <T extends Task | Task[], B>(
    url: string,
    payload?: B,
    config?: AxiosRequestConfig,
  ): Promise<T> => {
    return this.put<T, B, T>(url, payload, {
      ...(config ?? {}),
      params: {
        //  hasfieldsAccessMeta: true,
      },
    }).then((response) => transformResponse(response));
  };

  postWithTransformer = <T extends Task | Task[], B>(
    url: string,
    payload?: B,
    config?: AxiosRequestConfig,
  ): Promise<T> => {
    return this.post<T, B, T>(url, payload, {
      ...(config ?? {}),
      params: {
        //  hasfieldsAccessMeta: true,
      },
    }).then((response) => transformResponse(response));
  };
}
